<template>
    <div class="container">
        <triangle-image
          title="Non vi lasciamo<br>da soli!">

        </triangle-image>

        <div >
            <div class="content">

                <section class="section-how">
                    <div class="container-how">
                        <h2>Una guida passo per passo</h2>
                        <div class="col-xs-12">
                            <div class="flex-left">
                                <p>Con le nostre istruzioni non puoi sbagliare! Per ogni ricetta riceverai un cartoncino con le <b>illustrazioni</b> che ti guideranno nella preparazione: troverai tempi, dosi e utili consigli per un risultato garantito.</p>
                            </div>
                            <div class="flex-left">
                                <p>Ricordati che le nostre <b>ricette sono facili e veloci</b>, alla portata di tutti e non richiedono l'utilizzo di strumenti particolari da cucina.</p>
                            </div>
                            <div class="flex-center">
                                <p><br>Ecco un esempio, il nostro Padellata di manzo!</p>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="section-how">
                    <div class="container-how container-flyer-images">
                        <img src="../../assets/img/how/flyer-front.jpg" alt="Flyer Quomi fronte">
                        <img src="../../assets/img/how/flyer-back.jpg" alt="Flyer Quomi retro">
                    </div>
                    <div class="container-how">
                        <p class="text-center">
                            <br>...e le puoi trovare anche sul <a href="https://www.youtube.com/watch?v=xPHRBCRNVNI/videos?sort=dd&view=0&shelf_id=1" class="link-detail" title="YouTube Quomi">nostro canale Youtube</a></p>
                        <br>
                        <div class="video">
                            <iframe src="https://www.youtube.com/embed/xPHRBCRNVNI" frameborder="0" height="315" width="560" allowfullscreen>
                            </iframe>
                        </div>
                    </div>
                 </section>
                 <br><br>

                <div class="container-faq">
                    <i class="fa fa-question-circle fa-4x" aria-hidden="true"></i>
                    <br><h3>Domande frequenti</h3><br>
                    <p>Se hai ancora qualche dubbio, visita la nostra sezione <router-link :to="{name: 'faq'}" class="link-detail" title="Domande frequenti">domande frequenti</router-link><br>oppure scrivici in chat, la trovi qui a destra</p>

                </div>
                <br>
                <br>
            </div>

            <start-with-us></start-with-us>
        </div>

    </div>
</template>

<script>

import TriangleImage from '../TriangleImage'
import StartWithUs from '../Parts/StartWithUs'

export default {
	components: {
		'triangle-image': TriangleImage,
		'start-with-us': StartWithUs
	}

}

</script>

<style scoped>
    .triangle-image {
        background-image: url("../../assets/img/covers/box-hands.jpeg");
        background-position: center 0;
    }

    .container-how {
        max-width: 768px;
        margin: 0 auto;
    }

    .container-flyer-images img{
        max-height: 250px;
        border: 1px solid #ededed;
    }

    .video {
        height: 0;
        padding-bottom: 56.25%;
        padding-top: 30px;
        position: relative;
    }

    .video iframe,
    .video object,
    .video embed {
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
    }

    .box-quomi {
        max-width: 600px;
    }

    .text-left {
        text-align: left;
    }

    .section-how .fa {
        color: var(--quomi-primary);
    }

    .container-faq {
        max-width: 768px;
        margin: 30px auto;
        text-align: center;
        position: relative;
        border: 1px solid #575A5C;
        border-radius: 6px;
        padding: 20px;
    }

    .container-faq .fa-question-circle {
        color: var(--quomi-primary);
        position: absolute;
        background-color: white;
        top: 0px;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 0 20px;
    }

    .container-faq .title {
        font-size: 24px;
        position: absolute;
        background-color: white;
        top: 0px;
        font-weight: normal;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 0 20px;
    }

    .faq-title {
        text-transform: uppercase;
        font-size: 15px;
        margin-top: 30px;
    }

    .container-faq h3 {
        text-transform: uppercase;
    }

    @media only screen and (max-width: 1024px)  {
        .how {
            max-width: 90%;
            text-align: center;
            margin: 0px auto 30px auto;
        }

        .how .image {
            order: 2;
        }

        .how div {
            max-width: 600px;
        }

        .how .description {
            order: 1;
        }
    }

    @media only screen and (max-width: 600px)  {
        .img-box {
            height: 200px;
        }
    }

</style>
